module.exports = __webpack_public_path__ + "img/ico-2-active.6e7b79e7.svg";